import { FC, PropsWithChildren } from "react";
import { GoogleMapsProvider } from "./GoogleMapsContext";
import { SipContextProvider } from "./SipContext";
import { DecodedToken } from "./UserContext";
import { SipCallManager } from "@/components/sip/SipCallManager";
import { SoftphoneContextProvider } from "./SoftphoneContext";
import { useLocation } from "react-router-dom";
import { useTaxiSocket } from "@/hooks/useTaxiSocket";

interface RoleBasedContextProviderProps extends PropsWithChildren {
  decodedToken: DecodedToken | null;
}

const RoleBasedContextProvider: FC<RoleBasedContextProviderProps> = ({
  children,
  decodedToken,
}) => {
  useTaxiSocket(decodedToken?.settings.id || 0)
  const { pathname } = useLocation();
  const settingsType = decodedToken?.settings?.settings_type;

  // Show SipCallManager on all pages except homepage
  const showSipCall = pathname !== "/";

  // Base providers that all users need
  let content = children;

  // Apply GoogleMaps for all business types except auto_service
  if (settingsType !== "auto_service") {
    content = <GoogleMapsProvider>{content}</GoogleMapsProvider>;
  }

  // Apply SIP context only for taxi business type
  if (settingsType === "taxi") {
    // Use new global SIP implementation
    content = (
      <SoftphoneContextProvider>
        <SipContextProvider>
          {content}
          {showSipCall && <SipCallManager />}
        </SipContextProvider>
      </SoftphoneContextProvider>
    );
  }

  return <>{content}</>;
};

export default RoleBasedContextProvider;
